import { useContext } from 'react'

import { Context } from 'Root/Contexts/Token'

import { getSubjectFromJwt } from './subject-from-jwt'

export function useCurrentUserId(): string | null {
  const token = useContext(Context)

  return token ? getSubjectFromJwt(token) : null
}
